import { render, staticRenderFns } from "./LinkifiedText.vue?vue&type=template&id=e9747978&scoped=true&"
import script from "./LinkifiedText.vue?vue&type=script&lang=js&"
export * from "./LinkifiedText.vue?vue&type=script&lang=js&"
import style0 from "./LinkifiedText.vue?vue&type=style&index=0&id=e9747978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9747978",
  null
  
)

export default component.exports